@import '~style-sheet-helpers/core.less';

.restore-shipment-modal-body {
  padding: 16px 16px 64px;
}

.loading-indicator {
  height: 60px;
}

.restore-shipment-body-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.helper-text {
  font-size: 14px;
  line-height: 1.5;
}

.restore-shipment-modal-list {
  display: block;
  list-style-type: disc;
  padding: 1em;
  .restore-shipment-modal-bullet {
    display: list-item;
    line-height: 1.5em;
  }
}

.restore-shipment-modal-footer {
  .move-orders-button {
    margin-left: 10px;
  }
}
